import identity from "./component-library324.mjs";
import overRest from "./component-library489.mjs";
import setToString from "./component-library490.mjs";
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + "");
}
export {
  baseRest as default
};
